import React from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
// import { AddApproversModal } from './modals/add-approvers-modal';

const ViewCrqAddApprovers = React.memo(({
  crqId,
  network,
}) => {
  // const [modalOpen, setModalOpen] = useState(false);
  const history = useHistory();
  const navigateToSection7 = () => {
    history.push(`/crq/edit/fixed/${crqId}/APPROVERS_SECTION`);
  };
  return (
    <div className="view-crq-screen-add-approvers">
      <button
        type="button"
        className="view-crq-screen-add-approvers-button"
        // onClick={() => setModalOpen(true)}
        onClick={navigateToSection7}
      >
        Add Additional Approvers
      </button>
      {/* {modalOpen && (
        <AddApproversModal
          closeModal={() => setModalOpen(false)}
          crqId={crqId}
          network={network}
        />
      )} */}
    </div>
  );
});

ViewCrqAddApprovers.propTypes = {
  crqId: PropTypes.string,
  network: PropTypes.string,
};

export { ViewCrqAddApprovers };
